import { useParams } from "react-router";
import { nexusApi } from "src/common/service/nexus/nexusApi.js";
import { useLoadedCompanyDomain } from "src/routes/routeDataHooks.js";

/**
 * Domän/Företag trail: the domain crumb, plus the legal-entity crumb when the
 * route is scoped to one — mirrors the sidebar's Domän/Företag pickers.
 * Shared by HeaderLayout and the start dashboard, the only two places that
 * render this trail.
 */
export const useDomainBreadcrumbs = (): { label: string; href: string }[] => {
	const companyDomain = useLoadedCompanyDomain();
	const { legalEntityId } = useParams();
	const { data: legalEntities } =
		nexusApi.endpoints.getLegalEntities.useQueryState(companyDomain.id);
	const legalEntity = legalEntityId
		? legalEntities?.find((entity) => entity.id === legalEntityId)
		: undefined;

	return [
		{
			label: companyDomain.name,
			href: `/company-domains/${companyDomain.id}`,
		},
		...(legalEntity
			? [
					{
						label: legalEntity.name,
						href: `/company-domains/${companyDomain.id}/legal-entities/${legalEntity.id}`,
					},
				]
			: []),
	];
};
